import React, { useState } from 'react';

const Header = ({ activeTab, setActiveTab, balances, totalBalance, formatCurrency, exchangeRate, onUpdateRate }) => {
  const [showRateModal, setShowRateModal] = useState(false);
  const [newRate, setNewRate] = useState(exchangeRate);

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'add', label: 'Add', icon: '➕' },
    { id: 'transactions', label: 'History', icon: '📝' },
    { id: 'summary', label: 'Summary', icon: '📈' },
    { id: 'monthly', label: 'Analysis', icon: '📅' },
    { id: 'employees', label: 'Team', icon: '👥' },
    { id: 'subscriptions', label: 'Subs', icon: '🔔' }
  ];

  const handlePasswordManagerClick = () => {
    window.open('https://password.eynvision.com/', '_blank', 'noopener,noreferrer');
  };

  const handleUpdateRate = async () => {
    if (newRate && newRate > 0) {
      await onUpdateRate(newRate);
      setShowRateModal(false);
    }
  };


  return (
    <header className="sticky-header">
      <div className="container">
        {/* Top Bar: Logo and Total Balance */}
        <div className="flex justify-between items-center py-4 flex-mobile-col gap-4">
          <div className="logo-section">
            <h1 className="text-2xl font-bold logo-text">
              ⚡ Eynvision
            </h1>
            <p className="text-xs text-muted">Expense Tracker Pro</p>
          </div>

          <div className="flex items-center gap-4">
            {/* Bank Accounts - Compact */}
            <div className="hidden md:flex gap-3">
              <div className="account-pill alfalah">
                <span className="text-xs opacity-70">Alfalah:</span>
                <span className="font-bold">{formatCurrency(balances.alfalah || 0)}</span>
              </div>
              <div className="account-pill meezan">
                <span className="text-xs opacity-70">Meezan:</span>
                <span className="font-bold">{formatCurrency(balances.meezan || 0)}</span>
              </div>
              <div className="account-pill payoneer" onClick={() => { setNewRate(exchangeRate); setShowRateModal(true); }}>
                <span className="text-xs opacity-70">Payoneer:</span>
                <span className="font-bold">£{(balances.payoneer || 0).toFixed(0)}</span>
                <span className="text-xs opacity-50 ml-1">⚙️</span>
              </div>
            </div>

            <div className="total-balance-box">
              <p className="text-xs text-muted uppercase tracking-wider">Total Balance</p>
              <p className={`text-xl font-bold ${totalBalance >= 0 ? 'text-green' : 'text-red'}`}>
                {formatCurrency(totalBalance)}
              </p>
            </div>
          </div>
        </div>

        {/* Navigation Bar - Pill Style */}
        <nav className="nav-container pb-4">
          <div className="nav-scroll-wrapper">
            <div className="nav-pills">
              {tabs.map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`nav-pill ${activeTab === tab.id ? 'active' : ''}`}
                >
                  <span className="nav-icon">{tab.icon}</span>
                  <span className="nav-label">{tab.label}</span>
                </button>
              ))}
              <div className="nav-divider"></div>
              <button
                onClick={handlePasswordManagerClick}
                className="nav-pill secondary"
              >
                <span className="nav-icon">🔐</span>
                <span className="nav-label">Vault</span>
                <span className="external-icon">↗</span>
              </button>
            </div>
          </div>
        </nav>
      </div>

      {/* Rate Update Modal */}
      {showRateModal && (
        <div className="modal-overlay">
          <div className="card modal-content slide-up">
            <h3 className="text-xl font-bold mb-4 text-yellow">Update Exchange Rate</h3>
            <div className="form-group">
              <label className="form-label">GBP to PKR Rate</label>
              <input
                type="number"
                className="form-input"
                value={newRate}
                onChange={(e) => setNewRate(e.target.value)}
                step="0.01"
                autoFocus
              />
              <p className="text-xs text-muted mt-2">
                Current: {exchangeRate} PKR per GBP
              </p>
            </div>
            <div className="flex gap-3">
              <button onClick={handleUpdateRate} className="btn btn-primary" style={{ flex: 1 }}>Update</button>
              <button onClick={() => setShowRateModal(false)} className="btn btn-secondary" style={{ flex: 1 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <style dangerouslySetInnerHTML={{
        __html: `
        .sticky-header {
          position: sticky;
          top: 0;
          z-index: 100;
          background: rgba(10, 10, 10, 0.8);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border-bottom: 1px solid rgba(255, 255, 0, 0.2);
          margin-bottom: 2rem;
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5);
        }

        .logo-text {
          background: linear-gradient(135deg, var(--accent-yellow) 0%, #ffff66 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          filter: drop-shadow(0 0 10px rgba(255, 255, 0, 0.3));
        }

        .total-balance-box {
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 0, 0.3);
          padding: 0.5rem 1rem;
          border-radius: 12px;
          text-align: right;
          min-width: 160px;
        }

        .account-pill {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.4rem 0.8rem;
          border-radius: 20px;
          font-size: 0.8rem;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: all 0.2s ease;
        }

        .account-pill:hover {
          background: rgba(255, 255, 255, 0.1);
          border-color: var(--accent-yellow);
        }

        .account-pill.payoneer { cursor: pointer; }

        .nav-scroll-wrapper {
          overflow-x: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
          padding: 4px 0;
        }

        .nav-scroll-wrapper::-webkit-scrollbar { display: none; }

        .nav-pills {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 4px;
          background: rgba(255, 255, 255, 0.03);
          border-radius: 30px;
          width: max-content;
          border: 1px solid rgba(255, 255, 255, 0.05);
        }

        .nav-pill {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.6rem 1.2rem;
          border-radius: 25px;
          border: none;
          background: transparent;
          color: var(--text-secondary);
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          white-space: nowrap;
        }

        .nav-pill:hover {
          color: var(--text-primary);
          background: rgba(255, 255, 255, 0.05);
        }

        .nav-pill.active {
          background: var(--accent-yellow);
          color: var(--primary-bg);
          box-shadow: 0 4px 15px rgba(255, 255, 0, 0.4);
          transform: translateY(-1px);
        }

        .nav-divider {
          width: 1px;
          height: 24px;
          background: rgba(255, 255, 255, 0.1);
          margin: 0 0.25rem;
        }

        .nav-pill.secondary {
          opacity: 0.8;
        }

        .external-icon {
          font-size: 0.7rem;
          opacity: 0.6;
        }

        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.8);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 1rem;
        }

        .modal-content {
          width: 100%;
          max-width: 400px;
          border: 1px solid var(--accent-yellow);
          box-shadow: var(--glow);
        }

        @media (max-width: 768px) {
          .nav-pills {
            border-radius: 12px;
            padding: 2px;
          }
          .nav-pill {
            padding: 0.5rem 0.8rem;
            font-size: 0.8rem;
          }
        }
      `}} />
    </header>
  );
};

export default Header;